import React from "react";

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding p-t80 p-b10 bg-repeat">
          <div className="container">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner">
                  <h1 className="mb__30">300 Experts</h1>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 sx-separator-outer separator-center">
                <div className="case-logo custom__case_study_website_logo ">
                  <img
                    src={require("./../../../images/300_experts/logo.webp")}
                    className=""
                    alt="Shadow Case Study Logo"
                  />
                </div>
                <div className="mxnv046">
                  <h5 className="dfghj876543">300 Experts</h5>
                  <ul className="scnv-case">
                    <li>
                      <b>Location : </b>
                      Office 238, 2nd floor, Near Advant Navis Business Park,
                      Sector-142, Noida, UP-201305
                    </li>
                    <li>
                      <b>Speciality : </b> Real Estate
                    </li>
                    <li>
                      <b>Website : </b>{" "}
                      <a
                        href="https://300experts.com/"
                        class="text-white"
                        target="_blank"
                      >
                        www.300experts.com
                      </a>
                    </li>
                  </ul>

                  <div className="full-social-bg">
                    <h6 className="m-t0">Follow US: </h6>
                    <ul class="ertyupoi">
                      <li>
                        <a
                          href="https://www.facebook.com/300expertsofficial/"
                          class="facebook"
                          target="_blank"
                        >
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/300experts/"
                          class="instagram"
                          target="_blank"
                        >
                          <i class="fa fa-instagram"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.linkedin.com/company/300-experts/"
                          class="linkedin"
                          target="_blank"
                        >
                          <i class="fa fa-linkedin"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.youtube.com/@300Experts_official"
                          target="_blank"
                          class="youtube"
                        >
                          <i class="fa fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 sx-separator-outer">
                <div className="case-web-banner">
                  <img
                    src={require("./../../../images/300_experts/mobile_banner.webp")}
                    className="phone-banner"
                    alt="Shadow"
                  />
                  <img
                    src={require("./../../../images/300_experts/desktop_banner.webp")}
                    className="web-banner"
                    alt="Shadow"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="section-content">
              <div className="qpqq">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="bg-white">
                      <h2 class="ert678">Introduction</h2>
                      <p className="mb__0">
                        300 Experts is one of the best real estate company in
                        noida, run by a team of experienced professionals who
                        excel in the field of real estate. Their focus is always
                        serving their clients to the best of their ability. They
                        offer a comprehensive range of real estate solutions
                        catering to investors, brokers, corporations, and
                        property owners. Their team is committed to assisting
                        clients in making well-informed decisions. Also,
                        understanding and addressing the needs of their clients
                        is their top priority, ensuring they provide their
                        clients with the best possible solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
